import React from "react";
import PriceListItem from "../../components/price/PriceList/PriceListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const PriceListPage = ()  => {

    useTitle(t`List Price`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <PriceListItem showAdd={true} {...query} />
        </Box>
    )
}

export default PriceListPage;
